<template lang="html">
	<div
		class="omapi-subscribers-segments"
		:class="{
			'omapi-subscribers-segments__refreshing': isLoading,
			'omapi-subscribers-segments__no-data': !hasTags,
		}"
	>
		<monsterleads-search-button
			class="omapi-subscribers-segments__search"
			placeholder="Search Tags..."
			item="tags"
		/>

		<monsterleads-table-pagination :page-total="tags.length" />
		<table-base
			:headers="headers"
			:do-select-all="false"
			:is-loading="false"
			:show-footer="false"
			class="omapi-table"
		>
			<template v-if="tags">
				<monsterleads-segments-row v-for="tag in tags" :key="tag.id" :tag="tag"></monsterleads-segments-row>
				<tr class="omapi-table__footer">
					<table-cell :colspan="4">
						<core-button
							:link-style="true"
							class="omapi-table__footer-add nohover"
							@click="$modal.show('create-tag-modal')"
							>+ Add New Tag</core-button
						>
					</table-cell>
				</tr>
			</template>
		</table-base>
		<monsterleads-table-pagination :page-total="tags.length" />
		<monsterleads-modal-create-tag />
	</div>
</template>

<script lang="js">
import { mapState, mapGetters, mapActions } from 'vuex';
import { pagination } from '@/monsterleads/mixins/pagination';

export default {
	mixins: [pagination],
	data() {
		return {
			headers: [
				{ name: 'Tag Name', class: 'tag-table-name' },
				{ name: 'Created On', class: 'tag-table-created' },
				{ name: 'All Time Subscribers', class: 'tag-table-stats' },
				{ name: 'Last 30 Day Subscribers', class: 'tag-table-stats' },
			],
		};
	},
	computed: {
		...mapGetters(['connected', 'shouldFetchUser']),
		...mapState('monsterleads', ['tags', 'count']),
		isLoading() {
			return this.shouldFetchUser || this.$store.getters.isLoading('lead-tags');
		},
		hasTags() {
			return 0 < this.count;
		},
	},
	methods: {
		...mapActions('monsterleads', {
			fetch: 'fetchLeadsTags',
		}),
	},
};
</script>

<style lang="scss">
@import '../../../assets/scss/variables';
.omapi-screen .omapi-subscribers-segments {
	.omapi-table {
		border: none;
		&.striped > tbody > :nth-child(odd) {
			background-color: $color_white-button-background;
		}
		th {
			padding: 14px 30px;
			font-size: 13px;
			line-height: 1.5em;
			color: $color_black;
			border-bottom-color: $color_grey-light;
			&.tag-table-name {
				width: 150px;
				@media screen and (max-width: 1380px) {
					width: 75px;
				}
				@media screen and (max-width: 1170px) {
					width: 40px;
				}
			}
			&.tag-table-created {
				width: 110px;
				@media screen and (max-width: 1380px) {
					width: 75px;
				}
			}
			&.tag-table-stats {
				width: 50px;
				text-align: center;
				@media screen and (max-width: 1170px) {
					width: 40px;
				}
			}
		}
		td {
			padding: 22px 30px 23px;
			font-size: 13px;
			line-height: 1.5em;
			&.tag-table-stats {
				text-align: center;
			}
		}
		.tag-table-name {
			padding-left: 30px;
			&__title {
				margin-bottom: 1px;
				a {
					color: $color_black;
					font-weight: $font_bold;
					&:hover {
						color: $color_blue-primary;
						text-decoration: none;
					}
				}
			}
		}
		&__footer td {
			font-weight: $font_bold;
			color: $color_black;
			.omapi-table__footer-add {
				color: $color_black;
				&:hover {
					color: $color_blue-primary;
					text-decoration: none;
				}
			}
		}
	}
	.omapi-pagination {
		margin: 16px 0;
		justify-content: flex-end;
		height: 30px;
		@media screen and (max-width: 1150px) {
			justify-content: flex-start;
		}
	}
	&__search {
		display: flex;
		justify-content: flex-end;
		margin: -74px -10px 32px 0;
		@media screen and (max-width: 1150px) {
			justify-content: flex-start;
			margin: 0 0 16px;
			input[type='search'].omapi-input__inline {
				margin-left: 0;
			}
		}
	}

	&__refreshing {
		opacity: 0.5;
		&.omapi-subscribers-segments__no-data {
			td {
				padding-top: 34px;
				padding-bottom: 33px;
			}
		}
	}
}
// This along with the table min-width allows the full table to show on smaller screens
// by scrolling horizontally. The alternative is to probably hide some of the columns on
// smaller screens, which I'm not sure we want to do since we have functionality
// tied into each of the columns
@media screen and (max-width: 1150px) {
	.omapi-app-monsterleads #wpbody-content {
		overflow-x: scroll !important;
		.omapi-subscribers-segments {
			min-width: 910px;
			padding-right: 40px;
		}
	}
}
</style>
